import React from 'react'
import parse from 'html-react-parser'
import EmbedFrame from '../EmbedFrame'

const Block1 = (props) => {
  const { content } = props
  return (
    <div className='block1'>
      <div className='text-content'>
        {content?.text && parse(content.text)}
      </div>
      <div className='embed-content'>
        {content?.embed && <EmbedFrame embed={content.embed} />}
      </div>
    </div>
  )
}

export default Block1
